import { styled } from "@mui/material/styles";

// Components
import { Typography } from "@mui/material";
import { theme } from "~/components/Common";
import CategoryIcon from "~/components/Category/CategoryIcon";

const styledName = "TransactionItem";

export const StyledItemWrapper = styled("div", { name: styledName })({
  "&": {
    display: "flex",
    margin: "6px -20px",
    alignItems: "center",
    cursor: "pointer",
    padding: "0 10px",
    borderRadius: "10px",
    transition: "all 0.3s ease-in",
    ":hover": {
      backgroundColor: theme.palette.background.default,
    },
  },
});

export const StyledItemInfo = styled("div", { name: styledName })({
  "&": {
    borderBottom: `solid 1px ${theme.palette.grey[700]}`,
    display: "flex",
    flexDirection: "column",
    flexGrow: "1",
    marginLeft: "20px",
  },
});

export const StyledItemCategory = styled("div", { name: styledName })({
  "&": {
    display: "flex",
    justifyContent: "space-between",
  },
});

export const StyledCurrency = styled(Typography, { name: styledName })({
  "&": {
    color: theme.palette.info.dark,
    fontSize: "1.6rem",
  },
});

export const StyledCategoryIcon = styled(CategoryIcon, { name: styledName })({
  "&": {
    width: "36px",
    height: "36px",
  },
});
